<ax-icon
  *ngIf="showIcon"
  class="icon type-icon"
  [ngClass]="{single: isSingleCheck}"
  [name]="customIcon ? customIcon : 'card-text'"
></ax-icon>
<div>
  @if (isSingleCheck) {
    <div class="header">
      <mat-checkbox
        class="check"
        [ngClass]="{readonly: readonly}"
        [checked]="checked()"
        [disabled]="form.disabled || readonly"
        [required]="required"
        (change)="update(values[0] || 'true', $event.checked)"
      >
        {{ label }}<span *ngIf="required">&nbsp;*</span>
      </mat-checkbox>
      <button
        axButton
        icon-button
        type="button"
        *ngIf="form?.enabled && hasValue && !readonly"
        (click)="clearValue()"
      >
        <ax-icon class="icon" name="close"></ax-icon>
      </button>
    </div>
  } @else {
    <div class="header">
      <span class="label">{{ label }}<span *ngIf="required">&nbsp;*</span></span>

      <button
        axButton
        icon-button
        type="button"
        *ngIf="form?.enabled && hasValue && !readonly"
        (click)="clearValue()"
      >
        <ax-icon class="icon" name="close"></ax-icon>
      </button>
    </div>

    <div class="checkboxes">
      <mat-checkbox
        *ngFor="let valueTranslation of valueLabels"
        [value]="valueTranslation.value || ''"
        [ngClass]="{readonly: readonly}"
        [name]="getName() + ' ' + valueTranslation.value"
        [checked]="checked(valueTranslation.value)"
        [disabled]="form.disabled || readonly"
        [required]="required"
        (change)="update(valueTranslation.value, $event.checked)"
      >
        {{ valueTranslation.label }}
      </mat-checkbox>
    </div>
  }
</div>
<div class="hint-wrapper">
  @if (form.valid || form.untouched || form.disabled) {
    <mat-hint class="hint" align="end">
      {{ hint }}
    </mat-hint>
  }
  <ax-property-error *ngIf="form.touched" [form]="form" [label]="label"></ax-property-error>
</div>
